var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostPromotionDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16504 17.5V15.8333C3.16504 14.9493 3.51623 14.1014 4.14135 13.4763C4.76647 12.8512 5.61432 12.5 6.49837 12.5H9.83171C10.7158 12.5 11.5636 12.8512 12.1887 13.4763C12.8138 14.1014 13.165 14.9493 13.165 15.8333V17.5M13.9984 2.60833C14.7154 2.79192 15.3509 3.20892 15.8047 3.79359C16.2586 4.37827 16.5049 5.09736 16.5049 5.8375C16.5049 6.57764 16.2586 7.29673 15.8047 7.88141C15.3509 8.46608 14.7154 8.88308 13.9984 9.06667M18.165 17.5V15.8333C18.1608 15.0976 17.9133 14.384 17.4611 13.8037C17.0089 13.2233 16.3774 12.8089 15.665 12.625M4.83171 5.83333C4.83171 6.71739 5.1829 7.56523 5.80802 8.19036C6.43314 8.81548 7.28098 9.16667 8.16504 9.16667C9.04909 9.16667 9.89694 8.81548 10.5221 8.19036C11.1472 7.56523 11.4984 6.71739 11.4984 5.83333C11.4984 4.94928 11.1472 4.10143 10.5221 3.47631C9.89694 2.85119 9.04909 2.5 8.16504 2.5C7.28098 2.5 6.43314 2.85119 5.80802 3.47631C5.1829 4.10143 4.83171 4.94928 4.83171 5.83333Z",
    stroke: "#3C72ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostPromotionDash);
export default __webpack_public_path__ + "static/media/post_promotion_dash.13a0b983c8783a7944de38c5713609df.svg";
export { ForwardRef as ReactComponent };